import React from "react";

export const DOWNLOAD_URL = "https://berrymodapk.com/Apps/";

export const DICTIONARY = {
  en: {
    nav: {
      links: [
        { label: "Home", href: "#home" },
        { label: "Mods", href: DOWNLOAD_URL },
        { label: "Categories", href: "#ecosystem" },
        { label: "VIP Pricing", href: "https://berrymodapk.com/VIP" },
        { label: "About", href: "#about" },
      ],
      cta: "Explore Mods",
    },
    hero: {
      lines: ["The Future", "Of Modding", "Here."],
      subcopy:
        "Discover a new generation of Android customization, premium mods, and powerful experiences built for people who want more from their apps.",
      primaryCta: "Explore Mods",
      secondaryCta: "Discover BERRY MOD APK",
    },
    marquee: [
      "NO COMPROMISES",
      "ULTIMATE CONTROL",
      "PREMIUM MODS",
      "BUILT DIFFERENT",
      "ANDROID // UNLOCKED",
    ],
    about: {
      label: "What is Berry Mod Apk",
      heading1: "More Than",
      heading2: "Just",
      headingAccent: "Mods.",
      subcopy:
        "BERRY MOD APK is built around discovering, customizing, and experiencing Android applications in a fundamentally different way.",
      features: [
        {
          id: "modded",
          tag: "01",
          title: "Modded Experiences",
          body: "Discover enhanced versions of applications with carefully presented features and information.",
          icon: "Layers",
        },
        {
          id: "discovery",
          tag: "02",
          title: "Clean Discovery",
          body: "A structured platform designed to make finding applications and mods effortless.",
          icon: "Compass",
        },
        {
          id: "evolving",
          tag: "03",
          title: "Constantly Evolving",
          body: "New releases, updates, and experiences continuously added to the ecosystem.",
          icon: "GitBranch",
        },
      ],
    },
    ecosystem: {
      label: "The Ecosystem",
      heading1: "Your Android.",
      heading2: "Your",
      headingAccent: "Rules.",
      categories: [
        { id: "personalisasi", name: "Personalization", desc: "Custom themes, styles & layouts.", url: "https://berrymodapk.com/Category/?c=personalisasi", accent: "from-[#3B5BFF]/25" },
        { id: "enhancer", name: "Enhancer", desc: "HD upscaling, audio & visual boost.", url: "https://berrymodapk.com/Category/?c=hd", accent: "from-[#5B7CFF]/25" },
        { id: "games", name: "Games", desc: "Unlocked, tuned, unrestricted.", url: "https://berrymodapk.com/Category/?c=games", accent: "from-[#3B5BFF]/25" },
        { id: "tools", name: "Tools", desc: "Power features for power users.", url: "https://berrymodapk.com/Category/?c=tools", accent: "from-[#2B9FE2]/20" },
        { id: "social", name: "Social", desc: "Enhanced messaging & privacy features.", url: "https://berrymodapk.com/Category/?c=social", accent: "from-[#5B7CFF]/25" },
        { id: "ai", name: "AI", desc: "Smart assistants & neural intelligence.", url: "https://berrymodapk.com/Category/?c=ai", accent: "from-[#3B5BFF]/25" },
      ],
    },
    why: {
      label: "Why Berry",
      heading1: "Built",
      headingAccent: "Different.",
      principles: [
        { num: "01", title: "Curated", body: "Carefully structured and organized content." },
        { num: "02", title: "Fast", body: "Designed for a fast and frictionless experience." },
        { num: "03", title: "Modern", body: "A platform built around modern Android users." },
        { num: "04", title: "Evolving", body: "Continuously expanding with new releases and improvements." },
      ],
    },
    statement: {
      line1: "MODDING",
      line2: "HAS ENTERED",
      line3: "A NEW ERA.",
    },
    finalCta: {
      heading1: "Ready to Experience",
      heading2: "Android",
      headingAccent: "Differently?",
      subcopy: "Explore the BERRY MOD APK ecosystem and discover what's next.",
      button: "Explore BERRY MOD APK",
    },
    footer: {
      tagline: "The Future Of Modding is Here!",
      links: ["Home", "Mods", "Categories", "VIP Pricing", "About", "Contact", "Privacy", "Terms"],
    },
  },
  id: {
    nav: {
      links: [
        { label: "Beranda", href: "#home" },
        { label: "Aplikasi", href: DOWNLOAD_URL },
        { label: "Kategori", href: "#ecosystem" },
        { label: "Harga VIP", href: "https://berrymodapk.com/VIP" },
        { label: "Tentang", href: "#about" },
      ],
      cta: "Jelajahi Mod",
    },
    hero: {
      lines: ["Masa Depan", "Modding", "Ada Disini."],
      subcopy:
        "Temukan berbagai aplikasi modifikasi dengan fitur premium, vip, yang telah terbuka dan bebas iklan serta gratis. Jelajahi Sekarang!",
      primaryCta: "Jelajahi Mod",
      secondaryCta: "Pelajari BERRY MOD APK",
    },
    marquee: [
      "TANPA KOMPROMI",
      "KONTROL PENUH",
      "MOD PREMIUM",
      "DIRANCANG BERBEDA",
      "ANDROID // UNLOCKED",
    ],
    about: {
      label: "Tentang Berry Mod Apk",
      heading1: "Lebih Dari",
      heading2: "Sekadar",
      headingAccent: "Mod.",
      subcopy:
        "BERRY MOD APK dibangun untuk menemukan, menyesuaikan, dan merasakan aplikasi Android dengan cara yang benar-benar baru dan berbeda.",
      features: [
        {
          id: "modded",
          tag: "01",
          title: "Pengalaman Modifikasi",
          body: "Temukan versi Aplikasi yang telah disempurnakan dengan fitur yang jauh lebih bebas dan terbuka.",
          icon: "Layers",
        },
        {
          id: "discovery",
          tag: "02",
          title: "Eksplorasi Mudah",
          body: "Platform terstruktur yang dirancang agar menemukan aplikasi dan mod menjadi sangat praktis.",
          icon: "Compass",
        },
        {
          id: "evolving",
          tag: "03",
          title: "Terus Berkembang",
          body: "Rilisan baru, pembaruan, dan pengalaman canggih terus ditambahkan ke dalam ekosistem.",
          icon: "GitBranch",
        },
      ],
    },
    ecosystem: {
      label: "Ekosistem",
      heading1: "Android Anda.",
      heading2: "Aturan",
      headingAccent: "Anda.",
      categories: [
        { id: "personalisasi", name: "Personalisasi", desc: "Kustomisasi tema, gaya & tampilan.", url: "https://berrymodapk.com/Category/?c=personalisasi", accent: "from-[#3B5BFF]/25" },
        { id: "enhancer", name: "Enhancer", desc: "Peningkat kualitas visual & audio HD.", url: "https://berrymodapk.com/Category/?c=hd", accent: "from-[#5B7CFF]/25" },
        { id: "games", name: "Games", desc: "Unlocked, optimal, tanpa batas.", url: "https://berrymodapk.com/Category/?c=games", accent: "from-[#3B5BFF]/25" },
        { id: "tools", name: "Tools", desc: "Lebih Lengkap, Lebih Cepat.", url: "https://berrymodapk.com/Category/?c=tools", accent: "from-[#2B9FE2]/20" },
        { id: "social", name: "Social", desc: "Fitur privasi & perpesanan ekstra.", url: "https://berrymodapk.com/Category/?c=social", accent: "from-[#5B7CFF]/25" },
        { id: "ai", name: "AI", desc: "Asisten pintar & teknologi neural canggih.", url: "https://berrymodapk.com/Category/?c=ai", accent: "from-[#3B5BFF]/25" },
      ],
    },
    why: {
      label: "Mengapa Berry",
      heading1: "Dirancang",
      headingAccent: "Berbeda.",
      principles: [
        { num: "01", title: "Terkurasi", body: "Konten yang terstruktur dan tertata rapi secara profesional." },
        { num: "02", title: "Cepat", body: "Dirancang untuk pengalaman akses yang sangat cepat dan mulus." },
        { num: "03", title: "Modern", body: "Platform yang dibangun untuk ekosistem pengguna Android modern." },
        { num: "04", title: "Berkembang", body: "Terus diperluas dengan koleksi dan pembaruan rutin." },
      ],
    },
    statement: {
      line1: "MODIFIKASI",
      line2: "MEMASUKI",
      line3: "ERA BARU.",
    },
    finalCta: {
      heading1: "Siap Merasakan",
      heading2: "Android",
      headingAccent: "Secara Berbeda?",
      subcopy: "Jelajahi ekosistem BERRY MOD APK dan temukan inovasi terbaru sekarang.",
      button: "Jelajahi BERRY MOD APK",
    },
    footer: {
      tagline: "Masa Depan Modifikasi Ada di Sini!",
      links: ["Beranda", "Mod", "Kategori", "Harga VIP", "Tentang", "Kontak", "Privasi", "Ketentuan"],
    },
  },
};

// Backwards compatibility helpers
export const NAV_LINKS = DICTIONARY.en.nav.links;
export const FEATURES = DICTIONARY.en.about.features;
export const CATEGORIES = DICTIONARY.en.ecosystem.categories;
export const PRINCIPLES = DICTIONARY.en.why.principles;
export const FEATURED_MODS = [];
